import { useMutation } from '@tanstack/react-query';

import { handleError } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { deleteTemplateInstance } from '../../requests/deleteTemplateInstance';

export const useDeleteTemplateInstance = () => {
  const { constructDelete } = useRequestConstructor();

  const { mutateAsync, ...rest } = useMutation<unknown, Error, string>({
    mutationFn: (instanceId) =>
      deleteTemplateInstance(constructDelete, instanceId),
    onError: () => handleError('Failed to delete template.'),
  });

  return { deleteTemplateInstance: mutateAsync, ...rest };
};
